import Icon from "@/components/Icon/Icon";
import HStack from "@/components/Layout/HStack";
import { Text } from "@/components/Typography/Text";
import { Button } from "@/components/ui/button";
import { memo } from "react";

interface HighlyConfidentialTextFieldReadOnlyPresenterProps {
  /** 表示する値（マスクまたは実際の値） */
  displayValue: string;
  /** 秘匿値が表示されているかどうか */
  isRevealed: boolean;
  /** API呼び出し中かどうか */
  isLoading: boolean;
  /** 無効化されているかどうか */
  disabled?: boolean;
  /** テストID */
  testId?: string;
  /** 表示切り替えハンドラー */
  onToggleReveal: () => void;
}

/**
 * 高機密テキストフィールドの読み取り専用プレゼンター
 * 責務: 読み取り専用時のUI表示のみ
 */
export const HighlyConfidentialTextFieldReadOnlyPresenter = memo(
  ({
    displayValue,
    isRevealed,
    isLoading,
    disabled,
    testId,
    onToggleReveal,
  }: HighlyConfidentialTextFieldReadOnlyPresenterProps) => {
    // 値がない場合は目のアイコンを表示しない
    const hasValue = displayValue && displayValue.trim() !== "";

    return (
      <HStack className="items-center gap-2">
        <Text
          variant="secret"
          className="flex-1 text-neutral-on-fill break-words"
        >
          {displayValue}
        </Text>
        {hasValue && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onToggleReveal}
            disabled={disabled || isLoading}
            className="shrink-0"
            data-testid={`${testId}-reveal-button`}
          >
            {isLoading ? (
              <Icon iconName="Loader2Icon" className="w-4 h-4 animate-spin" />
            ) : (
              <Icon
                iconName={isRevealed ? "EyeOff" : "Eye"}
                className="w-4 h-4"
              />
            )}
          </Button>
        )}
      </HStack>
    );
  },
);

HighlyConfidentialTextFieldReadOnlyPresenter.displayName =
  "HighlyConfidentialTextFieldReadOnlyPresenter";
